/* ===========================================================================
   rr-prosa.js — 21/08/2026
   Envuelve las TABLAS que vengan del editor de texto enriquecido del admin en
   una caja con scroll horizontal propio, alcanzable por teclado.

   Por qué existe: el cuerpo de un artículo (y el de una página legal) lo escribe
   Pablo desde Shopify, así que puede pegar una tabla de cualquier ancho. Sin esto,
   una tabla ancha empuja el <body> y la página entera pasa a desbordar en
   horizontal — que es justo lo que el gate design-audit marca como FAIL, y lo que
   ya costó una ronda entera de arreglos el 30/07 con los ítems flex sin min-width.

   Mismo patrón, y a propósito, que la caja de scroll del comparador de la ficha de
   producto: role="region" + aria-label + tabindex="0" para que quien navega con
   teclado pueda desplazarla (WCAG 2.1.1). No se toca el marcado de la tabla, así
   que no se pierden sus semánticas de tabla.

   Si este script no llega a ejecutarse, el respaldo es puro CSS: la regla
   `.rr-prosa > table` de paginas.css le da scroll propio a la tabla mientras siga
   siendo hija directa de la prosa. Al envolverla deja de serlo y la regla se apaga
   sola.
   =========================================================================== */
(function () {
  'use strict';

  function envuelve(raiz) {
    var tablas = raiz.querySelectorAll('.rr-prosa table');
    for (var i = 0; i < tablas.length; i++) {
      var tabla = tablas[i];
      if (tabla.parentNode && tabla.parentNode.classList.contains('rr-prosa__tabla')) continue;

      var caja = document.createElement('div');
      caja.className = 'rr-prosa__tabla';
      caja.setAttribute('role', 'region');
      caja.setAttribute('tabindex', '0');
      caja.setAttribute('aria-label', 'Tabla, desplazable en horizontal');

      tabla.parentNode.insertBefore(caja, tabla);
      caja.appendChild(tabla);
    }
  }

  function arranca() {
    envuelve(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();
